var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 50,
    viewBox: "0 0 26 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7375 8.22493H25.9625V-7.3031e-05H18.125C18.125 -7.3031e-05 13.2 -0.125073 10.05 3.96243C10.05 3.96243 7.91251 5.97493 7.87501 11.8874V18.0499H0.125V26.7749H7.87501V49.3249H16.8125V26.7749H24.5L25.575 18.0499H16.8125V11.8874C16.8375 11.1999 17.15 8.16243 20.7375 8.22493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.0d05a809d0a1f8453ed0c4baff60229a.svg";
export { ForwardRef as ReactComponent };